import { Icon } from 'ui-kit-euroopt';
import cls from '../Footer/index.module.scss';
import { openCookiesModal } from '../modal/cookies';
import {useEffect, useState} from "react";
import {requestAdmin} from "../../helpers/request-admin";

type File = {
	id?: number;
	name: string;
	sort?: number;
	type?: string;
	url: string;
}

const results: File[] = [
	{
		name: 'Результаты розыгрышей по рекламной игре «Е-везунчики. Большой кэш» (23.07-16.09.2025)',
		url: '/assets/files/winners-big-cash.pdf',
	},
	{
		name: 'Результаты розыгрышей по рекламной игре «Е-везунчики. Летим домой!» (19.03-13.05.2025)',
		url: '/assets/files/winners_flying_home.pdf',
	},
	{
		name: 'Результаты розыгрышей по рекламной игре «Е-везунчики. Курс на деньги!» (15.01-11.03.2025)',
		url: '/assets/files/winners_curs_to_money3.pdf',
	},
	{
		name: 'Результаты розыгрышей по рекламной игре «Е-везунчики. По машинам!» (16.10–10.12.2024)',
		url: '/assets/files/winners-by-cars4.pdf',
	},
	{
		name: 'Результаты розыгрышей по рекламной игре «Е-везунчики. На домашнем!» (14.08–08.10.2024)',
		url: '/assets/files/winners-at-home4.pdf',
	},
	{
		name: 'Результаты розыгрышей по рекламной игре «Е-везунчики. На чиле!» (12.06–06.08.2024)',
		url: '/assets/files/winners-on-chill5.pdf',
	},
	{
		name: 'Результаты розыгрышей по рекламной игре «Е-везунчики. На драйве!» (10.04–04.06.2024)',
		url: '/assets/files/winners-on-drive2.pdf',
	},
	{
		name: 'Результаты розыгрышей по рекламной игре «Е-везунчики. Это любовь!» (17.01–12.03.2024)',
		url: '/assets/files/winners-love.pdf',
	},
	{
		name: 'Результаты розыгрышей по рекламной игре «Е-везунчики. Удваиваемся!» (28.09 – 22.11.2023)',
		url: '/assets/files/winners-doubling.pdf',
	},
];

const Footer = () => {
	const [files, setFiles] = useState<File[]>([]);

	useEffect(() => {
		requestAdmin.get<File[]>('docs')
			.then((result) => {
				setFiles(result);
			})
			.catch((e) => console.log('err', e));
	}, []);

	const winnersFiles = files.filter((file) => file.type === 'winners');

	return (
		<footer id="footer" className={cls.footer}>
			<div className={cls.footer__wrapper}>
				{(winnersFiles.length ? winnersFiles : results).map(({ name, url }, index) => (
					<div className={cls.footer__results} key={index}>
						<a href={url} target="_blank" rel="noreferrer">
							{name} <Icon name="chevron-12" />
						</a>
					</div>
				))}
				<div className={cls.footer__copyright}>
					Рекламная игра «Е-везунчики. Ключ к празднику» Срок проведения с 07.10.2026 по 04.02.2027 (включая период выдачи призов и публикации результатов). Свидетельство о регистрации №4706, выданное Министерством антимонопольного регулирования и торговли Республики Беларусь. ООО «ЭфСиБи Бел», УНП 193185741.
				</div>
				<button className={cls.cookie} onClick={() => openCookiesModal()}>
					Настройка согласия на файлы cookie
				</button>
			</div>
		</footer>
	);
};

export default Footer;
